import * as Icons from "heroicons-react";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDeleteUserMutation, useUsersQuery } from "../../services/userApi";
import "../Common/CSS/Table.css";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";

import { signInUser } from "../Utility/Auth";
import "./User.css";
import { useSelector } from "react-redux";

const User = () => {
  const authUser = signInUser();
    const lang = useSelector((state:any) => state.languageReducer);
    const{aamarId}= authUser || {}
  
  const [warehouse, SetWarehouse] = useState("allWh");
  const [loader, setLoader] = useState(true);
  const { data, error, isLoading, isFetching, isSuccess, refetch } =
    useUsersQuery(
      {
        warehouse: warehouse || "allWh",
        aamarId,
      },
      { skip: !aamarId }
    );
  // console.log(data);
  let i = 1;
  const [deleteUser] = useDeleteUserMutation();
  useEffect(() => {
    isFetching ? setLoader(true) : setLoader(false);
  }, [data, isLoading, isFetching]);
  useEffect(() => {
    refetch();
  }, [warehouse, aamarId]);
  // console.log("auth", authUser);

  useEffect(() => {
    if (authUser?.type === "admin" || authUser?.type === "owner") {
      SetWarehouse("allWh");
    } else {
      const wh = authUser?.warehouse;
      const warehouseValue =
        typeof wh === "string"
          ? wh
          : wh?._id || wh?.id || wh?.name || "allWh";
      SetWarehouse(warehouseValue || "allWh");
    }
  }, [authUser]);


  const deleteHandler = async (id: string, userRole?: string) => {
    if (userRole === "owner") {
      Swal.fire("Action Prohibited", "Store Owner cannot be deleted!", "warning");
      return;
    }
    const result = await Swal.fire({
      title: "Are you Sure?",
      text: "Delete this User?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      const res: any = await deleteUser(id);
      if (res?.error) {
        Swal.fire("Error!", res.error?.data?.message || "Failed to delete user", "error");
      } else {
        Swal.fire("Deleted!", "User has been deleted.", "success");
      }
    }
  };
  function isWarehouseObject(
    warehouse: unknown
  ): warehouse is { name: string } {
    return (
      typeof warehouse === "object" && warehouse !== null && "name" in warehouse
    );
  }
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-2">
          <SideBar></SideBar>
        </div>
        <div className="col-md-10">
          <Header title={lang?.allUsers}></Header>
          <div className="row pt-3">
            <div className="col-md-6">{/* <h3>All Users</h3> */}</div>

            <div className="col-md-6">
              <span className="float-end">
                <Link className="btn btn-dark" to="/user/add">
                  <Icons.UserAddOutline size={18}></Icons.UserAddOutline> {lang?.createUser || "Create User"}
                </Link>
              </span>
            </div>
          </div>

          {/* Responsive table with overflow */}
          <div className="table-responsive">
            <Table hover striped>
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Name</th>
                  <th scope="col">User Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Phone</th>
                  <th scope="col">Warehouse</th>
                  <th scope="col">Type</th>
                  <th scope="col">Status</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {isSuccess && (
                  <>
                    {data?.map((user, index) => (
                      <tr key={user?._id}>
                        <th scope="row">{index + 1}</th>
                        <td>{user?.name}</td>
                        <td>{user?.username}</td>
                        <td>{user?.email}</td>
                        <td>{user?.phone}</td>
                        <td>
                          {isWarehouseObject(user?.warehouse)
                            ? user?.warehouse?.name
                            : ""}
                        </td>
                        <td>{user?.type}</td>
                        <td>{user?.status}</td>
                        <td className="d-flex">
                          <Link to={`/user/${user._id}`}>
                            <Icons.EyeOutline className="icon-eye" size={22} />
                          </Link>
                          
                          <Link to={`/user/update/${user._id}`}>
                            <Icons.PencilAltOutline
                              className="icon-edit"
                              size={22} 
                            />
                          </Link>

                          {(authUser?.type === "admin" || authUser?.type === "owner") && user?.type !== "owner" && (
                            <Icons.TrashOutline
                              onClick={() => deleteHandler(user?._id, user?.type)}
                              className="icon-trash"
                              size={22}
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </>
                )}

                {isLoading && <h2>...Loading</h2>}
                {isFetching && <h2>...isFetching</h2>}
                {error && <h2>Something went wrong</h2>}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default User;
